export default __webpack_public_path__ + "media/images/icons/error-2c975776f63254bf64b74ba2c7e0efe5.svg";